import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';

import { Col, Row, Typography } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

import { styNotationBox, styDescription } from './style';

const PopUpMoreInfo = (props) => {
  const { show, onHide, specialNotation } = props;

  return (
    <PopUpCenterV2 size="md" show={show} scrollable title="Notasi Khusus" onHide={onHide}>
      {specialNotation.map((v) => (
        <Row key={v.code} gutters={8} align="left" marginTop={16}>
          <Col size="auto">
            <div className={styNotationBox}>{v.code}</div>
          </Col>
          <Col>
            <Typography type="label" margin={0} className={styDescription}>
              {v.description}
            </Typography>
          </Col>
        </Row>
      ))}
    </PopUpCenterV2>
  );
};

PopUpMoreInfo.propTypes = {
  show: bool,
  onHide: func,
  specialNotation: arrayOf(
    shape({
      code: string,
      description: string,
    })
  ),
};

PopUpMoreInfo.defaultProps = {
  show: false,
  onHide: () => {},
  specialNotation: [],
};

export default PopUpMoreInfo;
